import { authenticatedFetch } from '../api';

export type BillingModule = {
  code: string;
  name: string;
  billable: boolean;
  status: string;
  source: string | null;
  enabled: boolean;
};

export type BillingStatusResponse = {
  configured: boolean;
  mapping_configured: boolean;
  refreshed: boolean;
  stale: boolean;
  subscription: {
    state: 'unknown' | 'none' | 'trialing' | 'active';
    billing_period: string | null;
    cancel_at_end_of_cycle: boolean | null;
    trial_ends_at: string | null;
    cycle_start_at: string | null;
    cycle_end_at: string | null;
    item_handles: string[];
    pending_item_handles: string[];
    synced_at: string | null;
  };
  module_mapping: {
    unknown_item_handles: string[];
  };
  modules: BillingModule[];
  manage_plan_url: string | null;
  attention: string | null;
};

async function responseError(response: Response, fallback: string): Promise<Error> {
  const body = (await response.json().catch(() => null)) as { detail?: string } | null;
  return new Error(body?.detail ?? `${fallback} (${response.status})`);
}

export async function getBillingStatus(): Promise<BillingStatusResponse> {
  const response = await authenticatedFetch('/api/billing/status');
  if (!response.ok) throw await responseError(response, 'Could not load billing status');
  return (await response.json()) as BillingStatusResponse;
}

export async function refreshBillingStatus(): Promise<BillingStatusResponse> {
  const response = await authenticatedFetch('/api/billing/refresh', { method: 'POST' });
  if (!response.ok) throw await responseError(response, 'Could not verify Shopify subscription');
  return (await response.json()) as BillingStatusResponse;
}
